import EventEmitter from "./utils/EventEmitter";

export default class PageEvent extends EventEmitter {
    constructor(element) {
        super();

        this.el = element;

        this.live = this.el.querySelector('.live-iframe-wrapper')
        this.cover = this.el.querySelector('.cover-video')

        if (this.live) {
            this.createIframeLive()
        }
    }

    createIframeLive() {
        this.cover.classList.add('hidden')

        const iframe = document.createElement('iframe')
        iframe.src = this.live.getAttribute('data-live')
        iframe.width = '100%'
        iframe.height = '100%'
        iframe.frameborder = '0'
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        iframe.allowfullscreen = true

        this.live.appendChild(iframe)

    }

}
